import { ENV } from '@/configs/env';
import { useSignin } from '@hooks/useSignin';
import { GoogleIcon, AppleIcon } from '@hooks/auth/authSocialIcons';
import useThemeStore from '@stores/theme.store';
import Logo from '@/assets/logo.png';
import { Form, Input, Checkbox } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import Link from '@components/ui/Link';
import {
    LoginRoot,
    LoginBrandLogo,
    LoginWelcome,
    LoginSubtitle,
    LoginSocialBtn,
    LoginOr,
    LoginFormWrapper,
    LoginSubmitButton,
    DotWaveLoader,
} from '../style';

const Signin = () => {
    const { form, loading, onFinish, handleGoogle, handleApple, isMac, isRedirecting } = useSignin();

    if (isRedirecting) {
        return (
            <LoginRoot style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <DotWaveLoader aria-label="Redirecting">
                    <span />
                    <span />
                    <span />
                </DotWaveLoader>
            </LoginRoot>
        );
    }

    return (
        <LoginRoot>
            {/* <LoginBrandLogo src={Logo} alt="Sprinto" /> */}
            <LoginWelcome>Welcome back!</LoginWelcome>
            <LoginSubtitle>
                Don&apos;t have an account? <Link to={ENV.FRONT_FACING_URL || '/sign-up'}>Sign up</Link>
            </LoginSubtitle>

            {/* {isMac && (
                <LoginSocialBtn type="button" onClick={handleApple}>
                    <AppleIcon />
                    Continue with Apple
                </LoginSocialBtn>
            )}
            <LoginSocialBtn type="button" onClick={handleGoogle}>
                <GoogleIcon />
                Continue with Google
            </LoginSocialBtn> */}

            {/* <LoginOr>or</LoginOr> */}

            <LoginFormWrapper>
                <Form form={form} onFinish={onFinish} layout="vertical" requiredMark={false}>
                    <Form.Item name="email" rules={[{ required: true, message: 'Please enter your work email' }]}>
                        <Input placeholder="Work email" size="large" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Please enter your password' }]}
                        style={{ marginBottom: 12 }}
                    >
                        <Input.Password
                            placeholder="Password"
                            size="large"
                            iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                        />
                    </Form.Item>
                    <Form.Item name="remember" valuePropName="checked" style={{ marginTop: 0, marginBottom: 12 }}>
                        <Checkbox>Remember me</Checkbox>
                    </Form.Item>
                    <Form.Item>
                        <LoginSubmitButton
                            type="primary"
                            htmlType="submit"
                            block
                            disabled={loading}
                            size="large"
                            aria-busy={loading}
                        >
                            {loading ? (
                                <DotWaveLoader aria-label="Logging in">
                                    <span />
                                    <span />
                                    <span />
                                </DotWaveLoader>
                            ) : (
                                'Log in'
                            )}
                        </LoginSubmitButton>
                    </Form.Item>
                </Form>
            </LoginFormWrapper>

            <Link to="/forgot-password" block>
                Forgot Password?
            </Link>
        </LoginRoot>
    );
};

export default Signin;
